import { FC, useMemo } from 'react'
import cn from 'classnames'
import styles from 'components/features/coaching/advisor/AdvisorHeaderWith/AdvisorHeaderWith.styl'
import { AdvisorUid } from 'components/features/coaching/advisor/types/advisor'
import { createAdvisorSelector } from 'components/features/coaching/advisorMeeting/selectors/advisorsSelector'
import { useStoreSelector } from 'helpers/reactReduxHelpers'
import { AdvisorAvatar } from 'components/features/coaching/advisor/AdvisorAvatar/AdvisorAvatar'
import SvgIcon from 'components/atoms/SvgIcon'
import StarSvg from 'icons/star.svg'
import { AdvisorGrades } from 'components/features/coaching/advisor/AdvisorGrades/AdvisorGrades'
import { QAMarked } from 'interfaces/component'

type AdvisorHeaderWithProps = QAMarked & {
  uid: AdvisorUid
  showRating?: boolean
  vertical?: boolean
  smallAvatar?: boolean
}
export const AdvisorHeaderWith: FC<AdvisorHeaderWithProps> = (props) => {
  const { uid, vertical, showRating, smallAvatar, qaMarker, qaType } = props
  const advisorSelector = useMemo(createAdvisorSelector, [])
  const advisor = useStoreSelector((state) => advisorSelector(state, props))

  if (!advisor) {
    return <></>
  }

  const {
    name,
    rating,
    // reviews,
  } = advisor

  const stars = !!rating && (
    <div className={ styles.stars } data-qa-type='rating'>
      <i><SvgIcon src={ StarSvg } /></i>
      { parseFloat(rating).toFixed(1) }
    </div>
  )

  // TODO - Enable for Review viewing functionality
  // const dispatch = useStoreDispatch()

  // const handleShowReviews = useCallback(() => {
  //   dispatch(modifyFloatingPaneActionCreator('advisor', {mode: 'advisor', uid: advisor?.uid}))
  // }, [dispatch, advisor])

  // // const reviewChild = !!reviews && (
  //   <div className={ styles.reviews }>
  //     <a onClick={ handleShowReviews }>{ reviews.length } Reviews</a>
  //   </div>
  // )

  const ratingChild = !!showRating && (
    <div className={ styles.rating }>
      { stars }
      {/* { reviewChild } */}
    </div>
  )

  const advisorContent = (
    <>
      <div className={ cn(styles.avatar, { [styles.smallAvatar]: smallAvatar }) } data-qa-type='avatar'>
        <AdvisorAvatar uid={ uid } />
      </div>
      <div className={ styles.title }>
        <div className={ styles.name } data-qa-type='name'>
          { name }
        </div>
        <div className={ styles.grades } data-qa-type='grades'>
          <AdvisorGrades advisor={ advisor } />
        </div>
      </div>
    </>
  )

  return (
    <div 
      className={ cn(styles.advisorHeaderWith, { [styles.vertical]: vertical }) } 
      data-qa-type={ qaType } 
      data-qa-marker={ qaMarker }
    >
      { advisorContent }
      { ratingChild }
    </div>
  )
}
